'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _React = require('React');

var _React2 = _interopRequireDefault(_React);

var _reactUtils = require('react-utils');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _I18nReact = require('I18n.React.FormattedHTMLMessage');

var _I18nReact2 = _interopRequireDefault(_I18nReact);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _UICard = require('UIComponents/card/UICard');

var _UICard2 = _interopRequireDefault(_UICard);

var _utils = require('MeetingsLib/utils/utils');

var _ProfileHeader = require('MeetingsLib/components/header/ProfileHeader');

var _ProfileHeader2 = _interopRequireDefault(_ProfileHeader);

var _FreemiumUpgradeButton = require('MeetingsLib/components/freemium/FreemiumUpgradeButton');

var _FreemiumUpgradeButton2 = _interopRequireDefault(_FreemiumUpgradeButton);

var _UsageTracker = require('MeetingsLib/tracking/UsageTracker');

var _Branding = require('MeetingsBase/models/Branding');

var _Branding2 = _interopRequireDefault(_Branding);

var _UserProfile = require('MeetingsBase/models/UserProfile');

var _UserProfile2 = _interopRequireDefault(_UserProfile);

var _getFreemiumViralLink = require('MeetingsLib/components/freemium/getFreemiumViralLink');

var _getFreemiumViralLink2 = _interopRequireDefault(_getFreemiumViralLink);

var _paths = require('MeetingsLib/constants/paths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _React2.default.createClass({
  displayName: 'BookingSummary',

  propTypes: {
    avatar: _React.PropTypes.string,
    bookedDateTime: _React.PropTypes.number.isRequired,
    branding: _React.PropTypes.instanceOf(_Branding2.default).isRequired,
    embedded: _React.PropTypes.bool.isRequired,
    headline: _React.PropTypes.string,
    isSalesStarter: _React.PropTypes.bool,
    offline: _React.PropTypes.bool,
    profile: _React.PropTypes.instanceOf(_UserProfile2.default),
    userTimezone: _React.PropTypes.oneOf(_I18n2.default.moment.tz.names())
  },

  componentWillMount: function componentWillMount() {
    parent.postMessage({ meetingCreated: true }, '*');
  },
  componentDidMount: function componentDidMount() {
    (0, _UsageTracker.track)('meetingsLibViewScreen', { subscreen: 'summary' });
  },
  getPreMessageKey: function getPreMessageKey() {
    var offline = this.props.offline;

    var suffix = offline ? 'offline' : 'online';
    return 'summary.tagline.' + suffix;
  },
  goToMeetingsPage: function goToMeetingsPage() {
    (0, _UsageTracker.track)('meetingsLibClickPromoLink', {
      page: 'thank you'
    });
    var thankYouViralLink = (0, _getFreemiumViralLink2.default)(_paths.THANKYOU_VIRAL_HUBS_CTA);
    window.open(thankYouViralLink, '_blank');
  },
  renderAdvert: function renderAdvert() {
    var _props = this.props,
        isSalesStarter = _props.isSalesStarter,
        embedded = _props.embedded,
        branding = _props.branding;


    if (embedded || isSalesStarter) {
      return null;
    }

    return _React2.default.createElement(
      _UIFlex2.default,
      { align: 'center', justify: 'center' },
      _React2.default.createElement(_FreemiumUpgradeButton2.default, {
        handleButtonClick: this.goToMeetingsPage,
        branding: branding
      })
    );
  },
  render: function render() {
    var _props2 = this.props,
        embedded = _props2.embedded,
        bookedDateTime = _props2.bookedDateTime,
        userTimezone = _props2.userTimezone,
        profile = _props2.profile;


    var classes = (0, _reactUtils.classNames)('book-summary m-x-auto', {
      'p-top-12': !embedded
    });

    return _React2.default.createElement(
      'div',
      { className: classes, 'data-timestamp': bookedDateTime },
      _React2.default.createElement(
        _UICard2.default,
        { className: 'width-100 p-all-0' },
        _React2.default.createElement(
          'div',
          { className: 'm-bottom-8 m-x-4 p-y-11 p-x-3 text-center' },
          _React2.default.createElement(_ProfileHeader2.default, { booked: true, profile: profile }),
          _React2.default.createElement(
            'p',
            { className: 'text-center m-top-3' },
            _React2.default.createElement(_I18nReact2.default, {
              message: this.getPreMessageKey(),
              options: { fullName: (0, _utils.getLongDisplayName)(profile) }
            })
          ),
          _React2.default.createElement(
            'h4',
            { className: 'm-bottom-1 m-top-5' },
            _I18n2.default.moment(bookedDateTime).tz(userTimezone).format('LL')
          ),
          _React2.default.createElement(
            'h4',
            null,
            _I18n2.default.moment(bookedDateTime).tz(userTimezone).format('LT')
          ),
          this.renderAdvert()
        )
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/page/BookingSummary.js
// module id = 493
// module chunks = 0